import { t } from "ttag";

import type { ColorOption } from "./types";

export const getBrandColorOptions = (): ColorOption[] => [
  {
    name: "brand",
    label: t`Brand color`,
    description: t`The main color used throughout the app for buttons and links.`,
  },
  {
    name: "summarize",
    label: t`Summarize color`,
    description: t`The color of aggregations and breakouts in the graphical query builder.`,
  },
  {
    name: "filter",
    label: t`Filter color`,
    description: t`Color of filters in the query builder, buttons and links in filter widgets.`,
  },
];
